import React, {useEffect, useRef, useState} from 'react';
import NewsThumbnail from "./NewsThumbnail";
import {viewAlert} from "../SweetAlert/SweetAlert";
import {Link} from "react-router-dom";
import {getArticles, getCategories} from "../api/articles";
import notfoundimage from "../assets/default/notfound.png";

const Articles = () => {
    const [articles, setArticles] = useState([]);
    const [kegiatan, setKegiatan] = useState([]);
    const isMounted = useRef(false);

    useEffect(() => {
        if (isMounted.current) {
            return;
        }

        isMounted.current = true;
        fetchData()

        return () => {
            // Cleanup code here if necessary
        };
    }, []);

    const fetchData = async () => {
        await getCategories().then((res) => {
            return res.data
        }).then( async (resp) => {
            let artikelTemp = [];
            await getArticles().then((res) => {
                const response = res.data;

                response.forEach((data) => {
                    resp.forEach((category) => {
                        if (data.categoryId === category.id) {
                            data.categoryName = category.name;
                            artikelTemp.push(data)
                        }
                    })
                })

            }).catch(err => {
                viewAlert('Masalah!', err, 'error')
            });

            let tempArtikle = [];
            let tempKegiatan = [];
            artikelTemp.forEach((category) => {

                if (category.categoryName === "berita") {
                    tempArtikle.push(category)
                } else if (category.categoryName === "kegiatan") {
                    tempKegiatan.push(category)
                }
            })

            setArticles(tempArtikle);
            setKegiatan(tempKegiatan);
        }).catch(err => viewAlert('Masalah!', err, 'error'))
    }

    return (
        <div className="mx-auto">
            <div className="grid desktop:grid-cols-2 phone:grid-cols-1 gap-5">

                {articles.length === 0 ? (
                    <div>
                        <div>
                            <h1 className="text-3xl font-bold text-center mb-8">Informasi</h1>
                        </div>
                        <div className='flex items-center justify-center'>
                            <p>Tidak ada Informasi...</p>
                        </div>
                    </div>
                ) : (
                    <div className='bg-gray-200 rounded-lg'>
                        <h1 className="text-3xl font-bold text-center mt-5 mb-5">Informasi</h1>
                        <div className="grid desktop:grid-cols-1 phone:grid-cols-1 desktop:gap-2 phone:gap-2 mx-4 mb-4">
                            {articles.map((article, index) => (
                                <div key={article.id} className="m-0">
                                    <Link to={`/berita/${article.slug}`}>
                                        <NewsThumbnail
                                            imageUrl={article.image === "" ? {notfoundimage} : `/${article.image}`}
                                            title={article.title}
                                            description={article.description}
                                            date={article.createdAt}
                                            big={'object-center'}
                                        />
                                    </Link>
                                </div>
                            ))}
                        </div>
                        {articles.length > 4 ? (
                            <div className='flex flex-row pb-5 pr-5 items-end justify-end'>
                                <Link className="bg-blue-900 text-white rounded-md p-2 hover:bg-blue-950" to={'/berita'}>Tampilkan Kegiatan Lain -></Link>
                            </div>
                        ) : (
                            <div></div>
                        )}

                    </div>
                )}

                {kegiatan.length === 0 ? (
                    <div>
                        <div>
                            <h1 className="text-3xl font-bold text-center mb-8">Kegiatan</h1>
                        </div>
                        <div className='flex items-center justify-center'>
                            <p>Tidak ada kegiatan...</p>
                        </div>
                    </div>
                ) : (
                    <div className='bg-gray-200 rounded-lg'>
                    <h1 className="text-3xl font-bold text-center mt-5 mb-5">Kegiatan</h1>
                        <div className="grid desktop:grid-cols-1 phone:grid-cols-1 desktop:gap-2 phone:gap-2 mx-4 mb-4">
                            {kegiatan.map((article, index) => (
                                <div key={article.id} className="">
                                    <Link to={`/kegiatan/${article.slug}`}>
                                        <NewsThumbnail
                                            imageUrl={article.image === "" ? {notfoundimage} : `${article.image}`}
                                            title={article.title}
                                            description={article.description}
                                            date={article.createdAt}
                                            big={'object-center'}
                                        />
                                    </Link>
                                </div>
                            ))}
                        </div>
                        {kegiatan.length > 4 ? (
                            <div className='flex flex-row pb-5 pr-5 items-end justify-end'>
                                <Link className="bg-blue-900 text-white rounded-md p-2 hover:bg-blue-950" to={'/kegiatan'}>Tampilkan Informasi Lain -></Link>
                            </div>
                        ): (
                            <div></div>
                        )}
                    </div>
                )}
            </div>
        </div>
    );
};

export default Articles;